import React, { useCallback, useContext } from 'react';

import { HSTableContext } from '../../../Common/Table/HSTable/hs-table.context';
import { PpeDefinitionsContext } from '../ppe-definitions.context';
import PpeDefinitionFormDialog from './PpeDefinitionFormDialog';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData } = useContext(PpeDefinitionsContext);
  const { refresh } = useContext(HSTableContext);

  const closeDialog = useCallback(
    async (success: boolean) => {
      if (success) {
        await refresh();
      }
      setEditDialogOpened(false);
    },
    [refresh, setEditDialogOpened]
  );

  return <PpeDefinitionFormDialog open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
